import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles"
import MobileDateTimePicker from '@mui/lab/MobileDateTimePicker';
//import TextField from '@mui/material/TextField';
import { TextField, Input, InputAdornment, Checkbox } from '@material-ui/core';
import AdapterDateFns from '@mui/lab/AdapterMoment';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import IconButton from '@material-ui/core/IconButton';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import Button from "@material-ui/core/Button";
import moment from "moment"
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { toast } from "react-toastify";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { personalinfo } from "../../functions/auth";
import { postPost } from "../../functions/post";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({


    container: {
        borderRadius: "18px",
        padding: "30px",
        backgroundColor: "#fff",
        width: "875px",
        margin: "20px 40px",
        "@media (max-width: 770px)": {
            padding: "5%",
            margin: "0px",
            width: "90%"


        }

    },

    box: {
        margin: "25px 0px",
    },


    title: {



        fontSize: "17px",
        lineHeight: "60px",
        fontWeight: 600,
        width: "100%"

    },

    star: {

        color: theme.palette.secondary.main,
        //  float: "left"

    },

    input: {

        width: "85%",
        height: "58px",
        padding: "0 25px",
        border: "0px",
        backgroundColor: "#f3f3f3",
        fontSize: "20px",
        marginLeft: "20px",
        borderRadius: "5px",
        outline: "none",
        float: "right",
        //   fontWeight: 600,
        "@media (max-width: 770px)": {
            float: "left",
            width: "100%",
            marginLeft: "0"
        }

    },
    textInput: {
        width: "85%",
        float: "right",
        backgroundColor: "#f3f3f3",
        borderRadius: "5px",
        fontSize: "20px",
        "@media (max-width: 770px)": {
            float: "left",
            width: "100%",
        }
    },
    nickname: {
        marginLeft: "120px",
        fontWeight: 500,
        "@media (max-width: 770px)": {

            margin: "0px"

        }


    },
    name: {
        fontWeight: 500,
        color: "#999999",
        margin: "10px"

    },
    compensation: {
        display: 'flex',
        justifyContent: "flex-start",
        alignItems: "stretch",
        "@media (max-width: 770px)": {

            display: "inline-block"

        }



    },
    prizeTitle: {
        width: "80px",
        fontSize: "17px",
        lineHeight: "60px",
        fontWeight: 600,
    },
    prize: {

        width: "100%",
        marginLeft: "40px",
        padding: "10px 0px",
        display: 'flex',
        //justifyContent: "flex-start",
        flexDirection: "column",
        alignItems: "flex-start",
        "@media (max-width: 770px)": {

            display: "inline-block",
            width: "100%",
            margin: "0px",
            padding: "0px",

        }

    },
    prizeBox: {


        backgroundColor: "#f3f3f3",
        borderRadius: "5px",
        fontSize: "20px",
        margin: "5px",
        padding: "0px 10px",
        "@media (max-width: 770px)": {

            width: "95%",
            float: "right",

        },
        '&:hover': {
            borderColor: 'yellow',
        },


    },
    numBox: {

        backgroundColor: "#f3f3f3",
        borderRadius: "5px",
        fontSize: "20px",
        float: "right",
        margin: "5px",
        width: "200px",

        padding: "0px 10px",

        "@media (max-width: 770px)": {
            width: "95%",
        }

    },
    p: {

        fontSize: "17px",
        margin: "20px",
        color: theme.palette.secondary.main,
        fontWeight: 600,
        "@media (max-width: 770px)": {



            margin: "40px",


        }
    },
    imageContainer: {
        // margin: "10px",
        display: 'flex',
        flexWrap: 'nowrap',
        overflow: "auto",
        justifyContent: "space-between",
        width: "97%",
        borderRadius: "20px",
        backgroundColor: "#f3f3f3",
        float: "right",
        "@media (max-width: 770px)": {


            width: "100%",
            margin: "0px",
            padding: "0px",

        }

    },

    image: {
        width: "40%",
        margin: "5px",
        borderRadius: "30px"

    },

    display: {
        display: "none"
    },

    explain: {

        backgroundColor: "#f3f3f3",
        fontSize: "30px",
        fontWeight: 600,
        width: "84%",
        marginLeft: "45px",
        padding: "0px 5px",

        borderRadius: "10px",
        "@media (max-width: 770px)": {


            width: "98%",
            margin: "0px",


        }

    },

    button: {
        margin: theme.spacing(1),
        float: "right",
        color: "white",
        fontSize: "17px",
        fontWeight: 700

    }







}))

const CreatePost = () => {

    const history = useHistory();

    const styles = useStyles();
    const [images, setImages] = useState([]);
    const [img, setImg] = useState([]);
    const [title, setTitle] = useState("");
    const [target, setTarget] = useState("");
    const [author_info, setAuthor_info] = useState("");
    const [content, setContent] = useState("");
    const [nickname, setNickname] = useState(false);
    const [url, setUrl] = useState("");
    const [date, setDate] = useState(moment().format("YYYY-MM-DDThh:mm:ss"));
    const [deadline, setDeadline] = useState(moment().format("YYYY-MM-DDThh:mm:ss"));
    const [check, setCheck] = useState(false);
    const [prize, setPrize] = useState("");
    const [num_prize, setNum_prize] = useState(0);
    const [credit, setCredit] = useState(0);
    const [num_credit, setNum_credit] = useState(0);
    const [goal_participants, setGoal_participants] = useState(30);
    const [est_time, setEst_time] = useState(0);
    // const [event, setEvent] = useState(false);


    const onImage = async (e) => {

        const nowSelectImageList = e.target.files;
        const nowImageURLList = [];
        for (let i = 0; i < nowSelectImageList.length; i++) {
            const nowImageUrl = URL.createObjectURL(nowSelectImageList[i]);
            nowImageURLList.push(nowImageUrl);
        }
        // setImages({
        //     ...input,
        //     [e.target.name]: nowImageURLList
        // })

        setImages(nowImageURLList)
        setImg([...e.target.files]);

        // setImages([...e.target.files])

    }

    const participate = (e) => {
        setCheck(e.target.checked)
        setImages([])
        setImg([])
        setNum_credit(0)
        setNum_prize(0)
        setCredit(0)
        setPrize("")
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        if (title === "") {
            toast.warning("제목을 입력해주세요");
            return;
        }
        if (!target || target === "") {
            toast.warning("목표를 입력해주세요");
            return;
        }

        if (!goal_participants || goal_participants <= 0) {
            toast.warning("목표 참여자 수를 제대로 입력해주세요");
            return;
        }

        if (est_time === "") {
            toast.warning("예상 시간을 입력해주세요");
            return;
        }

        if (content === "") {
            toast.warning("내용을 입력해주세요");
            return;
        }

        if (!url.includes("https://forms.gle") && !url.includes("https://docs.google.com/forms")) {
            toast.warning("설문 url을 입력해주세요");
            return;
        }

        if (num_prize != img.length) {
            console.log(num_prize, img.length)

            toast.warning("상품의 개수와 이미지의 개수가 다릅니다");
            return;
        }

        try {

            const { userID, name } = await personalinfo();

            const formData = new FormData();

            formData.append("title", title);
            formData.append("target", target);
            formData.append("author", name);
            formData.append("content", content);
            formData.append("annonymous", author_info === "" && nickname === false ? true : false);
            formData.append("url", url);
            formData.append("date", date);
            formData.append("deadline", deadline);
            formData.append("prize", prize);
            formData.append("num_prize", num_prize);
            formData.append("credit", credit);
            formData.append("num_credit", num_credit);
            formData.append("goal_participants", goal_participants);
            formData.append("est_time", est_time);
            formData.append("event", 0);
            formData.append("author_userid", userID);

            for (var i = 0; i < img.length; i++) {
                formData.append("image", img[i])
            }


            const { result, message } = await postPost(formData);

            if (result === 1) {

                setTitle("")
                setTarget("")
                setContent("")
                setUrl("")
                setDate(moment().format("YYYY-MM-DDThh:mm:ss"))
                setDeadline(moment().format("YYYY-MM-DDThh:mm:ss"))
                setPrize("")
                setNum_prize(0)
                setCredit(0)
                setNum_credit(0)
                setGoal_participants(30)
                setEst_time(0)
                setImages([])
                setImg([])
                setCheck(false)
                setNickname(false)
                setAuthor_info("")
                toast.success("게시글이 작성되었습니다");

                setTimeout(() => {
                    history.push("/")
                }, 1000)

                return;
            } else {

                if (message === "not enough points") {
                    toast.error("크레딧이 부족합니다");
                    return;
                }

                toast.error("오류가 발생했습니다");

            }

        } catch (e) {

            console.log(e)
            toast.error("서버에러");

        }
    }

    return (
        <div className={styles.container}>
            <div className={styles.box}>
                <span className={styles.title}>설문 제목 <em className={styles.star}>*</em></span>
                <Input type="text" className={styles.input} required value={title} onChange={(e) => { setTitle(e.target.value) }} />
            </div>
            <div className={styles.box}>
                <span className={styles.title}>설문 대상 <em className={styles.star}>*</em></span>
                <Input type="text" className={styles.input} value={target} onChange={(e) => { setTarget(e.target.value) }} required />
            </div>
            <div className={styles.box}>
                <span className={styles.title}>연구자 </span>
                <Input type="text" className={styles.input} value={author_info} onChange={(e) => { setAuthor_info(e.target.value) }} />
            </div>
            <div>
                <div className={styles.nickname}>
                    <Checkbox onClick={(e) => { setNickname(e.target.checked) }} />
                    닉네임 사용
                    <div className={styles.name}>
                        미선택 시 익명으로 설정됩니다.
                    </div>
                </div>
            </div>


            <div className={styles.box}>
                <span className={styles.title}>목표 인원 <em className={styles.star}>*</em></span>
                <Input type="number" value={goal_participants} onChange={(e) => { setGoal_participants(e.target.value) }} className={styles.input} placeholder="숫자만 입력해주세요" endAdornment={<InputAdornment position="end">명</InputAdornment>} required />
            </div>


            <div className={styles.compensation}>
                <div>
                    <div className={styles.prizeTitle}> 참여 보상  </div>
                </div>
                <div className={styles.prize}>
                    <div>
                        <Checkbox onClick={(e) => { participate(e) }} />
                        체크하면 내용을 입력할 수 있습니다.
                    </div>
                    {check ?
                        <>
                            <div style={{ width: "100%" }}>

                                {/* <Checkbox /> */}
                                <Input className={styles.prizeBox} type="text" placeholder="아메리카노"
                                    value={prize} onChange={(e) => { setPrize(e.target.value) }}
                                    endAdornment={<InputAdornment position="end" style={{ color: "white" }}>크레딧</InputAdornment>}
                                />
                                <Input className={styles.numBox} value={num_prize} onChange={(e) => { setNum_prize(e.target.value) }} type="number" placeholder="인원수" endAdornment={<InputAdornment position="end">명</InputAdornment>} />

                            </div>
                            <div style={{ width: "100%" }}>

                                {/* <Checkbox /> */}
                                <Input className={styles.prizeBox} type="number" placeholder="크레딧 액수"
                                    value={credit} onChange={(e) => { setCredit(e.target.value) }}
                                    endAdornment={<InputAdornment position="end">크레딧</InputAdornment>}
                                />
                                <Input className={styles.numBox} value={num_credit} onChange={(e) => { setNum_credit(e.target.value) }} type="number" placeholder="크레딧 개수" endAdornment={<InputAdornment position="end">명</InputAdornment>} />

                            </div>
                            <br />
                            <div >
                                <div className={styles.p}>
                                    기프티콘 이미지를 업로드하면<br />
                                    설문조사 참여자들에게 추첨을 통해 자동으로 지급됩니다
                                </div>
                            </div>
                            <div>
                                <Checkbox />
                                <span>기프티콘(이미지) 올리기</span>
                                <input className={styles.display} onChange={(e) => onImage(e)} accept="image/*" id="icon-button-file" name="image_urls" multiple type="file" />
                                <label htmlFor="icon-button-file">
                                    <IconButton color="primary" aria-label="upload picture" component="span">
                                        <PhotoCamera />
                                    </IconButton>
                                </label>
                            </div>
                            <div>
                                <div className={styles.imageContainer}>


                                    {images.map((item, index) => (

                                        <img className={styles.image} src={item} key={index} alt={item} />

                                    ))}

                                </div>
                            </div>
                        </>
                        :
                        null}
                </div>
            </div>
            <div className={styles.box}>
                <div>
                    <span className={styles.title}>설문 링크 <em className={styles.star}>*</em></span>
                    <Input type="text" value={url} onChange={(e) => { setUrl(e.target.value) }} className={styles.input} placeholder="수정불가/구글폼만 지원하고 있습니다" required />
                </div>
            </div>
            <div className={styles.box}>
                <span className={styles.title}>마감 기한 <em className={styles.star}>*</em></span>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <MobileDateTimePicker
                        value={deadline}
                        onChange={(e) => { setDeadline(moment(e).format("YYYY-MM-DDTHH:mm:ss")) }}
                        disablePast
                        label="마감 기한"
                        onError={console.log}
                        maxDate={moment().add(14, 'days')}
                        inputFormat="       yyyy년  MM월  DD일   h시 mm분 a"
                        mask="   ___년 __월 __일  _시 __분 m"
                        renderInput={(params) => <TextField {...params} className={styles.textInput} />}
                    />
                </LocalizationProvider>
            </div>
            <div className={styles.box}>
                <span className={styles.title}>소요 시간 <em className={styles.star}>*</em></span>
                <FormControl variant="filled" className={styles.textInput}>
                    <InputLabel id="demo-simple-select-filled-label">소요시간</InputLabel>
                    <Select
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        value={est_time}
                        onChange={(e) => { setEst_time(e.target.value) }}
                        style={{ backgroundColor: "#f3f3f3" }}
                    >
                        <MenuItem value="">
                            <em>선택해주세요</em>
                        </MenuItem>
                        <MenuItem value={0}>1분 미만</MenuItem>
                        <MenuItem value={1}>1~2분</MenuItem>
                        <MenuItem value={2}>2~3분</MenuItem>
                        <MenuItem value={3}>3~5분</MenuItem>
                        <MenuItem value={4}>5~7분</MenuItem>
                        <MenuItem value={5}>7~10분</MenuItem>
                        <MenuItem value={6}>10분 초과</MenuItem>
                    </Select>

                </FormControl>
                {/* <Input type="number" className={styles.input} value={est_time} onChange={(e) => { setEst_time(e.target.value) }} placeholder="설문 참여에 소요되는 시간을 입력해주세요" endAdornment={<InputAdornment position="end">분</InputAdornment>} required /> */}
            </div>

            <div className={styles.box}>
                <span className={styles.title}>설문 내용 <em className={styles.star}>*</em></span>
                <TextField multiline minRows={10} value={content} onChange={(e) => { setContent(e.target.value) }} className={styles.explain} />
            </div>
            <div style={{ width: "100%", height: "50px" }}>
                <Button
                    className={styles.button}
                    variant="contained"
                    color="primary"
                    size="large"
                    startIcon={<CloudUploadIcon />}
                    onClick={(e) => { onSubmit(e) }}>
                    업로드
                </Button>
            </div>


        </div>
    );
};

export default CreatePost;